import selfHtml from './s41-msg_compose.html' with { type: 'text' };;
import templateHtml from './t01-avatars.html' with { type: 'text' };

import { mod_loader, BASEURL, InviteModule, MsgSentModule, SelectRCPTModule, MAX_BODY_SIZE } from "../AppState.js"
import { encrypt_gpg, get_pub_key, generateSecureString } from "../crypt_helper.js"
import {
    copy_to_clipboard, postData, collapse_show, collapse_hide, matrix_effect,
    form_validate, showOffcanvas, parseSizeToBytes, navbar_active_menu,
    show_modal, styleAvatar
} from "../utils.js";

import secrets from "../lib/secrets.js";

let payload_cleartext;

var free_text;
var passwordInput;
var url_input;
var file_input;

var armoured_text;
var armoured_text_length;
var timeout_pltext = null
var select_ttl
var psk_password = null

var chkAutodestruct

var chkNotifyOnIntendedRecipient
var chkNotifySenderOnSomeElse
var chkgrpNotifyOptions

var collapse_notif
var rcpt_pubkey_belongs_to_self

var isEncryptionReady = false;
var access_method_all

var original_color_charcount
var recipient_pub_keys_array = []

var activeTabId = "text-tab"

var quorum_min_threshold = 0 // this is set by the user in the offcanvas panel

var my_pubkey

var root


export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    $e(root).getEl("templates_container").innerHTML = templateHtml;

    my_pubkey = await get_pub_key();

    rcpt_pubkey_belongs_to_self = root.querySelector('.rcpt_pubkey_belongs_to_self')

    free_text = root.querySelector("#free_text");
    passwordInput = root.querySelector('.passwordInput');
    file_input = root.querySelector('.file_input');
    url_input = root.querySelector('.url_input');

    armoured_text = root.querySelector("#armoured_text");
    armoured_text_length = root.querySelector(".armoured_text_length");
    select_ttl = root.querySelector("#message_select_ttl");
    access_method_all = root.querySelectorAll('input[name="access_method"]')
    chkAutodestruct = document.getElementById("flexCheckAutodestruct");

    // notifications
    chkgrpNotifyOptions = root.querySelector(".chkgrpNotifyOptions");
    chkNotifyOnIntendedRecipient = root.querySelector("#chkNotifyOnIntendedRecipient");
    chkNotifySenderOnSomeElse = root.querySelector("#chkNotifySenderOnSomeElse");

    // input elements
    free_text.addEventListener("input", () => pltext_changed());
    passwordInput.addEventListener("input", () => pltext_changed());
    url_input.addEventListener('input', async () => pltext_changed());
    file_input.addEventListener('change', async () => pltext_changed());

    root.querySelectorAll(".copy_link_to_clipboard").forEach(element => {
        element.addEventListener("click", () => copy_to_clipboard(element));
    });

    chkNotifyOnIntendedRecipient.addEventListener('click', () => enable_notifications());
    chkNotifySenderOnSomeElse.addEventListener('click', () => enable_notifications());
    root.querySelector(".btn_request_auth_notification").addEventListener('click', () => request_auth_notification());

    navbar_active_menu(".msg_compose")

    original_color_charcount = armoured_text_length.style.color

    if (await get_pub_key() == null) {
        showOffcanvas('offcanvasAddkeyPanel', async () => {
            init(root, args);
        });
        return;
    }

    // Initialize tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')

    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    payload_cleartext = {
        type: activeTabId,
        body: "",
        filename: "",
    }

    // Bootstrap form validation and onClick action
    form_validate(root, async () => {
        generate_link(root)
    });

    if (args != null) {
        // A recipient has been selected, coming form the URI
        $("access_method_single").checked = true
        on_btnaccess_method_all() // set the clicked radio button color
        add_recipient([{ username: args.myKeyPairUserID[0], pubkey: args.myKeyPairPublicKey }])
        $e(root).getEl("secured_with_threshold").classList.add("d-none");
        collapse_show(root.querySelector(".secured_with_psk"));
        free_text.focus();
    }
    else
        recipient_pub_keys_array.length = 0;

    // highlight selected radio button
    access_method_all.forEach((btn) => {
        btn.addEventListener('click', (ev) => {
            on_btnaccess_method_all(ev)
        })
    })

    collapse_notif = new bootstrap.Collapse(chkgrpNotifyOptions, { toggle: false });

    init_onGeteratePassword();

    init_onTabChange();

    new ResizeObserver((() => {
        let currentHeight = Number(free_text.style.height.replace("px", ""));
        armoured_text.style.height = (currentHeight - 30) + "px";
    })).observe(free_text)


}
// -------------------------------------------------
export async function add_recipient(contacts) {

    // Export function
    // This function is called by the init of this module, and by the s940-select_rcpt

    const container = $e(root).getEl("display_pubkey_recipients");

    recipient_pub_keys_array.length = 0;

    container.innerHTML = "";

    if (contacts.length == 0) {

        // when s940 rctp select calls this function with [] empty, hide the 

        enableChkNotifySenderOnSomeElse(false);
        return
    }

    collapse_hide(rcpt_pubkey_belongs_to_self);

    for (const contact of contacts) {
        recipient_pub_keys_array.push(contact.pubkey)
        const tpl_endorser = $e(root).getEl("tpl-badge-endorser");
        const node = tpl_endorser.content.cloneNode(true);
        const badge = node.querySelector("span.badge");
        badge.style.background = "#f0f4ff";
        badge.style.color = "#1a1a2e";
        styleAvatar(node.querySelector(".avatar"), { fullname: contact.username, pgp_pubkey: contact.pubkey }, 22);
        node.querySelector(".name").textContent = contact.username;
        container.appendChild(node);
    }

    enableChkNotifySenderOnSomeElse(true);

    pltext_changed()
}
// -------------------------------------------------
export function set_threshold(num) {
    quorum_min_threshold = Number(num);
}
// -------------------------------------------------
function enableChkNotifySenderOnSomeElse(bool) {
    chkNotifySenderOnSomeElse.disabled = !bool;
    const tooltip = bootstrap.Tooltip.getInstance(root.querySelector(".divNotifySenderOnSomeElse"))
    if (bool == false) {
        chkNotifySenderOnSomeElse.parentNode.setAttribute("data-bs-title", "Select a recipient to enable this option");
        chkNotifySenderOnSomeElse.checked = false;
        tooltip.enable()
    }
    else {
        chkNotifySenderOnSomeElse.parentNode.removeAttribute("data-bs-title");
        tooltip.disable()
    }

}
// -------------------------------------------------

async function pltext_changed() {

    clearTimeout(timeout_pltext);

    isEncryptionReady = false;

    payload_cleartext.type = activeTabId
    payload_cleartext.filename = ""
    payload_cleartext.shares = []
    payload_cleartext.body = ""

    switch (activeTabId) {
        case 'text-tab':
            payload_cleartext.body = free_text.value;
            break;
        case 'password-tab':
            payload_cleartext.body = passwordInput.value;
            break;
        case 'url-tab':
            payload_cleartext.body = url_input.value;
            break;
        case 'file-tab':
            if (file_input.files.length != 1)
                return;
            payload_cleartext.body = await file_input.files[0].stream().getReader().read();
            payload_cleartext.filename = file_input.files[0].name;
            break;
        case 'offlineenc-tab': // TODO
            payload_cleartext.body = 'TODO';
            break;
        default:
            throw Error("Unexpected activeTabId")
    }

    root.querySelector(".clear_text_length").innerText = free_text.value.length

    if ($("access_method_quorum").checked == true)
        if (recipient_pub_keys_array.length < 2) {
            recipient_pub_keys_array = [];
            update_armoured_text("");
            return;
        } else {

            $e(root).getEl("threshold_quorum").innerText = quorum_min_threshold;
            $e(root).getEl("threshold_participants").innerText = recipient_pub_keys_array.length;
        }

    if (isEmpty(payload_cleartext.body)) {
        armoured_text.value = "";
        armoured_text_length.innerText = 0;
        hideMatrixEffect()
        return;
    }

    document.body.style.cursor = 'wait';

    if (psk_password == null && recipient_pub_keys_array.length == 0) {
        update_armoured_text("");
        return;
    }

    showMatrixEffect();

    timeout_pltext = setTimeout(async () => {

        var enc = "";
        try {
            if ($("access_method_quorum").checked == true) {

                const quorum_psk_password = secrets.random(512) // => key is a hex string

                const enc = await encrypt_gpg(JSON.stringify(payload_cleartext), quorum_psk_password, []);
                payload_cleartext.body = "" // Erase ASAP the cleartext that was just encrypted

                const payload = {
                    armoured_text: enc,
                    pgp_pub_rcpt: recipient_pub_keys_array,
                    ttl: select_ttl.value,
                    pgp_pubkey: my_pubkey.myKeyPairPublicKey,
                    autodestruct: chkAutodestruct.checked,
                    notify_sender_on_intended: chkNotifyOnIntendedRecipient.checked,
                    notify_sender_on_fail: chkNotifySenderOnSomeElse.checked,
                }

                const message_data = await postData(BASEURL.api + '/post_note', payload);

                if (message_data.success !== true)
                    return console.warn(message_data);

                // Add one to quorum_min_threshold because the UI is about 'endorsements'
                var shares = secrets.share(quorum_psk_password, recipient_pub_keys_array.length, quorum_min_threshold);

                // create and bind one share per participant
                for (const k in shares) {
                    const recipient_pub_key = recipient_pub_keys_array[k];
                    const share_4_single_rcpt = await encrypt_gpg(shares[k], null, [recipient_pub_key]);
                    payload_cleartext.shares.push({ armoured_share: share_4_single_rcpt, rcpt_pubkey: recipient_pub_key });
                }

                payload_cleartext.body = message_data.hash;

                payload_cleartext.quorum_min_threshold = quorum_min_threshold;

                payload_cleartext.type = "quorum-tab";

            }
            enc = await encrypt_gpg(JSON.stringify(payload_cleartext), psk_password, recipient_pub_keys_array);
        } catch (err) {
            console.log(err);
        } finally {
            update_armoured_text(enc);
            timeout_pltext = null;
        }
    }
        , 500);
}

// -------------------------------------------------

async function update_armoured_text(str) {

    // The encryption is completed

    document.body.style.cursor = 'default';

    armoured_text.value = str

    armoured_text_length.innerText = armoured_text.value.length

    if (armoured_text.value.length > parseSizeToBytes(MAX_BODY_SIZE) * 0.95 - 1000)
        armoured_text_length.style.color = "red"
    else
        armoured_text_length.style.color = original_color_charcount;

    if (timeout_pltext != null) {
        if (await get_pub_key() != null)
            isEncryptionReady = true;
        hideMatrixEffect();
    }

}

// -------------------------------------------------

async function generate_link(el) {

    if (timeout_pltext != null)
        return;

    if (isEmpty(payload_cleartext.body)) {
        show_modal("Nothing to encrypt", "Please select a message to encrypt")
        return;
    }

    if (isEncryptionReady == false) {
        console.log("Too fast, encryption not ready");
        return
    }

    const spinner_border = el.querySelector('.spinner-border')

    spinner_border.style.display = "" // show spinner

    el.disabled = true

    try {

        const rcpt_pubkey = $("access_method_direct").checked ? null : recipient_pub_keys_array;

        const payload = {
            armoured_text: armoured_text.value,
            pgp_pub_rcpt: rcpt_pubkey,
            ttl: select_ttl.value,
            pgp_pubkey: my_pubkey.myKeyPairPublicKey,
            autodestruct: chkAutodestruct.checked,
            notify_sender_on_intended: chkNotifyOnIntendedRecipient.checked,
            notify_sender_on_fail: chkNotifySenderOnSomeElse.checked,
        }

        const data = await postData(BASEURL.api + '/post_note', payload);

        free_text.value = "cleared for security reason";

        data.psk_password = psk_password;
        data.sender_address = my_pubkey;
        data.recp_address = rcpt_pubkey;

        mod_loader(MsgSentModule, { data });
    } catch (err) {
        console.log(err)
    } finally {
        spinner_border.style.display = 'none' // show spinner
        el.disabled = false
    }

}

// -------------------------------------------------

function showMatrixEffect() {
    matrix_effect(document.querySelector(".encryption_matrix_effect"), true)
}
// -------------------------------------------------
function hideMatrixEffect() {
    matrix_effect(document.querySelector(".encryption_matrix_effect"), false)
}
// -------------------------------------------------
async function enable_notifications() {

    if (Notification.permission === 'granted')
        return

    if (!chkNotifyOnIntendedRecipient.checked && !chkNotifySenderOnSomeElse.checked)
        return

    collapse_notif.show(); // Show button to open offcanvas

    showOffcanvas('offcanvasNotificationPanel', () => {
        if (Notification.permission !== 'granted') {
            chkNotifyOnIntendedRecipient.checked = false;
            chkNotifySenderOnSomeElse.checked = false;
        }
    });

}
// -------------------------------------------------
async function request_auth_notification() {

    document.querySelector(".notificationTriggerBtn").disabled = false;

    showOffcanvas('offcanvasNotificationPanel');

}
// -------------------------------------------------
function on_btnaccess_method_all(ev) {
    access_method_all.forEach(element => {
        const cl = element.parentElement.querySelector("label").classList;
        const bs_icon = element.parentElement.querySelector(".bi").classList;
        const checked = ["border-primary", "bg-primary", "bg-opacity-10"]
        const unchecked = ["border-secondary-subtle"]
        const bs_icon_active = "text-primary"
        if (element.checked) {
            cl.add(...checked)
            cl.remove(...unchecked)
            bs_icon.add(bs_icon_active)
        } else {
            cl.add(...unchecked)
            cl.remove(...checked)
            bs_icon.remove(bs_icon_active)
        }
    });

    switch (ev?.target?.id) {
        case 'access_method_direct':
            collapse_show(root.querySelector(".can_open_anyone_warning"));
            collapse_hide(root.querySelector(".rcpt_pubkey_belongs_to_self"));
            collapse_hide(root.querySelector(".secured_with_psk"))
            enableChkNotifySenderOnSomeElse(false);
            recipient_pub_keys_array.length = 0;
            $e(root).getEl("display_pubkey_recipients").innerHTML = "";
            psk_password = generateSecureString(22)
            pltext_changed()
            return
        case 'access_method_single':
            recipient_pub_keys_array.length = 0;
            $e(root).getEl("display_pubkey_recipients").innerHTML = "";
        // There is no 'return' or 'break' here. Continue with the next line.
        case 'access_method_team':
            // Do this for both Team and Single. There is no 'break'on the case above
            collapse_show(root.querySelector(".secured_with_psk"))
            collapse_hide(root.querySelector(".can_open_anyone_warning"));
            $e(root).getEl("secured_with_threshold").classList.add("d-none");
            break;
        case 'access_method_quorum':
            collapse_show(root.querySelector(".secured_with_psk"))
            collapse_hide(root.querySelector(".can_open_anyone_warning"));
            $e(root).getEl("secured_with_threshold").classList.remove("d-none");
            break;
        case undefined:
            // User exit offcanva without selecting enything, or
            // this is the homepage with a pubkey ion the URL
            return;
        case 'default':
            throw Error("Should not reach here, on_btnaccess_method_all ev?.target?.id ");
    }

    psk_password = null

    pltext_changed();

    SelectRCPTModule.refresh(ev?.target?.id, recipient_pub_keys_array);
    showOffcanvas('offcanvasSelectRCPTPanel', on_offcanvasSelectRCPTPanel_close);

}
// ------------------------------------------------------------------------------------------------------------
function on_offcanvasSelectRCPTPanel_close() {

    if (recipient_pub_keys_array.length == 1 && recipient_pub_keys_array[0] == my_pubkey.myKeyPairPublicKey) {
        collapse_show(root.querySelector(".rcpt_pubkey_belongs_to_self"));
    }

    if (psk_password == null)
        collapse_hide(root.querySelector(".can_open_anyone_warning"));

    if (recipient_pub_keys_array.length == 0) {
        access_method_all.forEach((btn) => { btn.checked = false })
        collapse_hide(root.querySelector(".secured_with_psk"));
        on_btnaccess_method_all(null);
        return;
    }

    pltext_changed();
}

// ------------------------------------------------------------------------------------------------------------

function init_onTabChange() {

    root.querySelector('.mode_tabs_menu').addEventListener('shown.bs.tab', event => {

        activeTabId = event.target.id; // The tab that was just activated

        // Cleanup 
        free_text.value = "";
        passwordInput.value = "";
        root.querySelector('.url_input').value = "";
        root.querySelector('.file_input').value = "";

        pltext_changed();

        // Unused
        const previousTabId = event.relatedTarget.id; // The tab that was active before.

    });
}
// ------------------------------------------------------------------------------------------------------------
function init_onGeteratePassword() {
    // Initialize Chance
    const chance = new Chance(); // https://chancejs.com/

    // Elements
    const generateBtn = root.querySelector('.generateBtn');
    const lengthRange = document.getElementById('secretPasswordLength');  // has a "for" label
    const lengthVal = root.querySelector('.lengthVal');

    root.querySelector(".show_hidden_password").addEventListener('click', () => { passwordInput.type = 'text'; })

    // Update badge display
    lengthRange.addEventListener('input', () => {
        lengthVal.textContent = lengthRange.value;
    });

    generateBtn.addEventListener('click', () => {
        // 1. Gather options
        const length = parseInt(lengthRange.value);
        const options = {
            upper: root.querySelector('#secretPasswordCheckUpper').checked,
            lower: root.querySelector('#secretPasswordCheckLower').checked,
            numeric: root.querySelector('#secretPasswordCheckNumbers').checked,
            symbols: root.querySelector('#secretPasswordCheckSpecial').checked
        };

        // 2. Map checkboxes to a pool of characters
        let pool = '';
        if (options.upper) pool += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        if (options.lower) pool += 'abcdefghijklmnopqrstuvwxyz';
        if (options.numeric) pool += '0123456789';
        if (options.symbols) pool += '!@#$%^&*()_+';

        // 3. Use Chance to generate the string from the pool
        if (pool.length > 0) {
            const password = chance.string({ length: length, pool: pool });

            passwordInput.value = password;

            pltext_changed();

            // Visual feedback: briefly show password
            passwordInput.type = 'text';
            setTimeout(() => { passwordInput.type = 'password'; }, 1500);

        } else {
            passwordInput.value = '';
            show_modal('Generate Password', 'Please select at least one character type');
        }
    });
}

// ------------------------------------------------------------------------------------------------------------

function isEmpty(value) {
    if (value == null) return true;

    if (typeof value === "string") {
        return value.trim() === "";
    }

    if (value instanceof Uint8Array) {
        return value.length === 0;
    }

    return false;
}
